// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"db62c427","86":"58459b44","88":"e5f028b6","115":"9757f1b1","185":"71289bcd","247":"9817d53c","428":"dc94a5fc","512":"996b0b34","536":"8154eae5","625":"278e4859","878":"452f3cbd"}[chunkId] + ".chunk.js";
};